import React, { Component } from 'react'
import NavBar from './NavBar';
import Footer from './Footer';
import Painel from './Painel';
 

class Content extends Component {

    constructor(props){
        super(props); 
        const usuario   = sessionStorage.getItem('usuario');
        const empresa   = sessionStorage.getItem('fantasia');
        const grupo     = sessionStorage.getItem('grupo');

         
        if( !usuario ) {
            console.log('aqui')
            this.props.history.push('/');
        }
    }

    render() {
    
    return  <div className="wrapper">
                <NavBar/>                
                <div className="content-wrapper">
                    { this.props.children }
                </div>
                
                <Footer/>

            </div>             
    }
}

export default Content;
